// client/src/features/ledger/enums.ts — the ledger's wire enums, as runtime lists.
//
// The construction `features/expenses/enums.ts` documents: the generated client gives each enum
// as a string-literal UNION with no runtime value, so each list is spelled out once and HELD to
// its union by an exhaustive `Record<T, true>`. A member the contract adds and this file lacks —
// or one this file keeps after the contract dropped it — is a compile error in the PR that
// regenerated the client.
//
// Labels stay in `romanian.json` under `enums.{EnumName}.{VALUE}` (04 §9.6.3). The row kind is
// FIN-002's own `CashFlowKind` (D-2134), which no screen had rendered before this one, so its
// `enums.CashFlowKind` block is new; `PaymentMethod` already had one.

import type { CashFlowKind, PaymentMethod } from '@/client';

/** The six row kinds, in the cash flow's own order: in, in, out, then the three memo kinds. */
const CASH_FLOW_KIND_ORDER: Record<CashFlowKind, true> = {
  RENT_COLLECTED: true,
  UNALLOCATED_CREDIT: true,
  EXPENSE_PAID: true,
  DEPOSIT_RECEIVED: true,
  DEPOSIT_RETURNED: true,
  DEPOSIT_RETAINED: true,
};

export const CASH_FLOW_KINDS = Object.keys(CASH_FLOW_KIND_ORDER) as readonly CashFlowKind[];

/** The six ways money moves, in the seed's order — the method filter's options. */
const PAYMENT_METHOD_ORDER: Record<PaymentMethod, true> = {
  BANK_TRANSFER: true,
  CASH: true,
  CARD: true,
  DIRECT_DEBIT: true,
  COMPENSATION: true,
  OTHER: true,
};

export const PAYMENT_METHODS = Object.keys(PAYMENT_METHOD_ORDER) as readonly PaymentMethod[];

/** Whether a URL value names a method — the schema's guard, so `?method=x` is dropped, not sent. */
export function isPaymentMethod(value: unknown): value is PaymentMethod {
  return typeof value === 'string' && (PAYMENT_METHODS as readonly string[]).includes(value);
}
